import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import PrivacyPolicy from "./sections/PrivacyPolicy";
import GlossyBottomNavigation from "./sections/GlossyBottomNavigation";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <PrivacyPolicy />
      <GlossyBottomNavigation />
      <Footer />
    </div>;
}